/* BVONA — Charm swatch swap + Cart free bag prompt */
(function(){

  var CHARM_IMAGES = {
    'Serpente': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/charmsnakeoff.jpg',
    'Serpente Argento': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/files/Charm_snake_silver_off.jpg',
    'Croce': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/Charmcrossoff.jpg',
    'Mano Cornuta': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/Charmmanooff.jpg',
    'Sacro Cuore': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/Charmheartoff.jpg',
    'Tredici': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/13-off.jpg',
    'Vaffanculo': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/Charmvafangoff.jpg',
    'In Bocca al Lupo': 'https://cdn.shopify.com/s/files/1/0590/4777/2325/products/lupooffblueoff.jpg'
  };

  function swapSwatches() {
    var fieldsets = document.querySelectorAll('.variant-picker__option');
    var charmFieldset = null;
    fieldsets.forEach(function(f) {
      var legend = f.querySelector('legend');
      if(legend && legend.textContent.trim() === 'Charm') charmFieldset = f;
    });
    if(!charmFieldset) return;
    var thumbs = charmFieldset.querySelectorAll('.option-value--thumbnail');
    thumbs.forEach(function(thumb) {
      var label = thumb.querySelector('.option-value__label');
      if(!label) return;
      var charmName = label.textContent.trim();
      var charmImg = CHARM_IMAGES[charmName];
      if(!charmImg) return;
      var img = thumb.querySelector('img');
      if(img) { img.src = charmImg; img.srcset = charmImg; }
    });
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapSwatches);
  } else {
    swapSwatches();
  }
  document.addEventListener('variant:changed', function() { setTimeout(swapSwatches, 50); });
  setInterval(swapSwatches, 500);

  // ——— FREE BAG PROMPT IN CART ———
  var PROMPT_ID = 'bvona-free-bag-prompt';

  function injectFreeBagPrompt() {
    if(document.getElementById(PROMPT_ID)) return;
    var prompt = document.createElement('div');
    prompt.id = PROMPT_ID;
    prompt.style.cssText = 'padding: 0.75rem 1rem;';
    prompt.innerHTML = '<a href="/collections/bvona-fortvna-complimentary-bag" style="display:block;background:#000;color:#fff;text-align:center;padding:1rem;text-decoration:none;font-size:0.72rem;letter-spacing:0.12em;text-transform:uppercase;">+ SELECT YOUR COMPLIMENTARY BAG &rarr;</a><p style="font-size:0.65rem;text-align:center;opacity:0.5;margin:0.4rem 0 0;">Included with your purchase — select a second bag at no charge</p>';
    var target = document.querySelector('.cart-drawer__footer, .cart__footer, [class*="cart"][class*="footer"]');
    if(target) {
      target.insertBefore(prompt, target.firstChild);
    } else {
      var checkout = document.querySelector('[name="checkout"], a[href*="checkout"]');
      if(checkout) checkout.parentNode.insertBefore(prompt, checkout);
    }
  }

  document.addEventListener('cart:refresh', function() { setTimeout(injectFreeBagPrompt, 400); });
  document.addEventListener('click', function(e) {
    if(e.target.closest('[aria-controls*="cart"], [data-action*="cart"]')) setTimeout(injectFreeBagPrompt, 500);
  });
  setInterval(injectFreeBagPrompt, 1000);

})();
